(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ako-back-to-top"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var backTop = document.querySelector('div.ako-backtop');
    if (!backTop) return;

    backTop.addEventListener('click', function (event) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    function updateBackTopVisibility() {
      var isVisible = window.scrollY > 0;
      backTop.classList.toggle('ako-opacity', isVisible);
      backTop.classList.toggle('ako-hide', !isVisible);
    }

    document.addEventListener('scroll', updateBackTopVisibility, { passive: true });
    updateBackTopVisibility();
  });

  } catch(e) { console.error(e); }
})();
})();
